export default __webpack_public_path__ + "static/media/icon_photoblogs.ad766749.svg";